(function () {
    'use strict';

    angular
        .module('searchModule')
        .controller('SearchFacetsController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        // Show refine facets by id
        $scope.showRefineFacetsById = function (byRefineFacetId) {
            return _.some(byRefineFacetId.RefineFacetsByColumnValue, function (byColumnValue) {
                return !byColumnValue.isHidden;
            });
        };

        // Show RefineBy section
        $scope.showRefineBySection = function () {
            return _.some($scope.refineFacetCtx.byRefineFacetId, function (byRefineFacetId) {
                return $scope.showRefineFacetsById(byRefineFacetId);
            })
        };

        // Clear facets
        $scope.clearFacets = function () {
            $scope.hierarchicalFacetCtx.levels              = [];
            $scope.refineFacetCtx.selected                  = {};
            $scope.refineFacetCtx.selectedPerson            = null;
            $scope.hierarchicalFacetCtx.hasSomeBeenSelected = false;
            $scope.refineFacetCtx.hasSomeBeenSelected       = false;
            $scope.updateHierarchicalFacetContext($scope.hierarchicalFacetCtx.rootInstanceId, true); // forceRefresh: true
        }

        // Show clear facets
        $scope.showClearFacets = function () {
            return $scope.hierarchicalFacetCtx.hasSomeBeenSelected || $scope.refineFacetCtx.hasSomeBeenSelected;
        }

        // Show person profile
        $scope.showPersonProfile = function () {
            if (!$scope.refineFacetCtx.selectedPerson) {return false;}

            return _.some($scope.refineFacetCtx.byRefineFacetId, {RefineFacetID: 2014}); // Person: 2014
        };
    }
})();












